import React from 'react';
import { Row, Col } from 'react-bootstrap';
import MediaQuery from 'react-responsive';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Textbox from "../../UI/Textbox/Textbox";
import Button from '../../UI/Button/Button';
import CandidatePhoto from '../../CandidatePhoto/CandidatePhoto';
import print from '../../../assets/images/print.png';
import './CandidateOverview.css';
import ToggleButton from '../../UI/ToggleButton/ToggleButton';
import {relativeTime} from '../../../shared/utility';
import { noticePeriod,jobType } from '../../../shared/constants';
import Select from '../../UI/Select/Select';
import Icon from '../../UI/Icon/Icon';
import ConsoleLog from './../../../hoc/ConsoleLog/ConsoleLog';

/**
* @desc Highlight   experience in candidate profile section
* @param props
* @return DOMElement
*/
const HighlightExperience = (props) => {
  return (
    <div className="highlight-experience">
      <MediaQuery query="(max-device-width: 767px)">
        <span className="job-title">{(props.JobTitle)}</span><br /><span className="company">{props.CurrentEmployer?props.CurrentEmployer:'- Not Specified -'}</span>
      </MediaQuery>
      <MediaQuery query="(min-device-width: 768px)">
        <span className="job-title">{props.JobTitle}</span> <span className="divider">|</span> <span className="company">{props.CurrentEmployer?props.CurrentEmployer:"- Not Specified -"}</span>
      </MediaQuery>
    </div>
  );
}
/**
* @desc CandidateOverview in candidate profile section
* @param props
* @return DOMElement
*/

const CandidateOverview = (props) => {  
  //ConsoleLog("name edit",props);
  ConsoleLog('props printed here', props )
  const noticePeriodValue =(props.candidate.notice_period && props.candidate.notice_period !== null) ? props.candidate.notice_period : 'SELECT' ;
  const jobTypeValue = (props.candidate.job_type && props.candidate.job_type !== null) ?
     (props.candidate.job_type==="Contractor, Permanent"||props.candidate.job_type==="Permanent, Contractor")?"Contractor, Permanent":props.candidate.job_type
   : 'SELECT' ;
 
  const noticePeriodOptions = Object.keys(noticePeriod).map((notice) => {
    return <option value={notice}>{noticePeriod[notice]}</option>
  });
 
  const jobTypeOptions = Object.keys(jobType).map((job) => {
    return <option value={job}>{jobType[job]}</option>
  });
  
  return (
    <div className="candidate-overview">                      
      {(props.isCandidateScoring || props.isProfileEdit||props.isPrint) ? 
          null 
        : <div className="cv-link">
            <MediaQuery query="(min-device-width: 768px)">
              {/* <Link to={"/profile/print/"+ props.activeCandidateId}></Link> */}
              <button onClick={()=>window.print() }></button>
            </MediaQuery>
            <MediaQuery query="(max-device-width: 767px)">            
              {/* <button className="print-button" onClick={props.handlePrintProfileMobile}></button> */}
              <button onClick={()=>window.print() }></button>
            </MediaQuery>          
          </div> 
        }
        {(props.isProfileEdit && !props.isPreview) ? 
          <span className="candidate-bh-id-label">BH ID 
            <span className="candidate-bh-id-number">
              {props.candidate.candidate_source_id}
            </span>
          </span> 
        :""}
        <div className="profile-picture-container">
          <div className={(props.isProfileEdit)? "profile-picture upload-profile-image" : "profile-picture" } onClick={(props.isProfileEdit)?(() => props.imageUpdateModal()):(() => null)}>
            <CandidatePhoto 
              initials={props.candidate.initials} 
              candidatePhoto={props.candidate.s3SignedUrl} 
              user={props.user} 
              attributes={props.attributes} 
              isS3Url={props.isS3Url} 
            />         
          </div>
          {(props.isProfileEdit && !props.isPreview) ? 
            <div className="toggle-button-wrapper">
              <ToggleButton 
                isChecked={props.isChecked}
                handleToggleStatus={props.handleToggleStatus}
                disabled={props.completedDisabled}
              />              
              <div 
                className={"check-status-text " + props.checkStatusText.toLowerCase().replace(" ", "-") }
              >
                {props.checkStatusText}
              </div>
            </div> 
          : null }
        </div>
        <div className="details">   
          {(props.isProfileEdit) ? 
            <div className="preview-button-wrapper">
              <Button 
                className="btn btn-lg btn-preview" 
                value={props.candidate_id} 
                onClick={(event) => props.handleCandidatePreview(event)} 
              >
                {(props.isPreview) ? "Exit Preview" : "Preview" }
              </Button>
            </div>
          :
            <div className="pool-status-buttons">
              {/* <Button className={props.candidate_status=="REGRET" ? "btn btn-lg btn-regret btn-active" : "btn btn-lg btn-regret"} value={props.candidate_id} onClick={() => props.open("REGRET", props.candidate_id)} bsSize="large" bsStyle="danger">
                Regret
              </Button> */}
              {/* <Button className={props.candidate_status=="PROGRESS" ? "btn btn-lg btn-progress btn-active" : "btn btn-lg btn-progress"} value={props.candidate_id} onClick={() => { props.onPoolStatusChange(props.candidate_id, "PROGRESS",props.jobTitleId, false);props.open("PROGRESS", props.candidate_id)}} bsSize="large" bsStyle="success">
                Progress
              </Button> */}
            </div>
          }      
          <div className="candidate-name-wrapper">
            <MediaQuery query="(max-device-width: 767px)">
              <div className="title-container">
              {/* {(props.isProfileEdit && !props.isPreview) ? 
                <span className="candidate-bh-id-label">Bullhorn ID 
                  <span className="candidate-bh-id-number">
                    {props.candidate.candidate_source_id}
                  </span>
                </span>  */}
              <span className="candidate-status-icon">
                {(props.candidate_status && props.candidate_status !== "" && !props.isPreview) ? 
                  <div className={props.candidate_status.toLowerCase() + "-icon"}></div> 
                  : null
                }
              </span>
              <h1 className="main">{props.candidate.candidate_name.trim() ? props.candidate.candidate_name : props.isProfileEdit && !props.isPreview ? "Add Name":"Not Specified"} </h1>    
              </div>     
            </MediaQuery>
            
            <MediaQuery query="(min-device-width: 768px)">
            {(props.isNameEdit ) ?
              <Textbox  
                className="candidate-edit-input"
                id="candidateName" 
                autoFocus={props.isFocus?true :false}
                value={props.candidate.candidate_name} 
                placeholder="Add Name"
                onChange={(event) => props.handleCandidateNameChange(event,props.candidate_id)}
                onBlur={(event) => props.handleCandidateNameOnBlur(event,props.candidate_id)} 
              />:
              <h1 className="candidate-name">{props.candidate.candidate_name.trim() ? props.candidate.candidate_name : props.isProfileEdit && !props.isPreview ? "Add Name":"Not Specified"}</h1>
            }
            {(!props.isNameEdit && !props.isPreview && props.isProfileEdit) ?
              <Icon 
                icon="Candidate-name-edit" 
                className="candidate-name-edit-icon" 
                onClick={(event) =>props.handleCandidateNameEdit(event)}
              ></Icon>
            :""}
              {/* {(props.isProfileEdit && !props.isPreview) ? 
                <span className="candidate-bh-id-label">Bullhorn ID 
                  <span className="candidate-bh-id-number">
                    {props.candidate.candidate_source_id}
                  </span>
                </span> 
              : */}
              <span className="candidate-status-icon">
                {(props.candidate_status && props.candidate_status !== "" && !props.isPreview) ? 
                  <div className={props.candidate_status.toLowerCase() + "-icon"}></div> : 
                  null
                }
              </span>
              {/* }     */}
            </MediaQuery>
          </div>

          {/* {props.candidate.experience.filter((currentExp) => (currentExp.current_role === "1" && currentExp.title !== "" && currentExp.company !== "")).length > 0 ?
            props.candidate.experience.filter((currentExp) => (currentExp.current_role === "1" && currentExp.title !== "" && currentExp.company !== "")).map((currentExp, index) => {
              if(index > 0) {
                return;
              }
              return (
                <HighlightExperience 
                  key={index}
                  JobTitle={currentExp.title} 
                  CurrentEmployer={currentExp.company} 
                />
              ); 
            
             }) : 
              <div>
                <span className="not">Actively Seeking Employment</span>
              </div>

          } */}

          {/* edited here */}
          {props.candidate.experience.filter((currentExp) => currentExp.current_role === "1").length > 0 ?
          props.candidate.experience.filter((currentExp) => currentExp.current_role === "1").map((currentExp, index) => {
            if(index > 0) {
              return;
            }
            return (
              <HighlightExperience 
                JobTitle={currentExp.title} 
                CurrentEmployer={currentExp.company} 
              />
            ); 
          
            }) : 
            ((props.candidate.current_job_title && props.candidate.current_employer) ?
            <HighlightExperience 
              JobTitle={props.candidate.current_job_title} 
              CurrentEmployer={props.candidate.current_employer} 
            /> 
            : 
            <div>
              <span className="not">Actively Seeking Employment</span>
            </div>
          )
        }

          <div className="email-wrapper">
            <MediaQuery query="(min-device-width: 768px)">
            {(props.isEmailEdit||props.errorPosition==='Email' ) ?
              <Textbox 
                className={props.errorPosition==='Email'?"candidate-edit-email-input error-message":"candidate-edit-email-input"}
                id="candidateName" 
                autoFocus={props.isFocus?true :false}
                value={props.candidate.candidate_email} 
                placeholder="Add Email Address"
                onChange={(event) => props.handleCandidateEmailChange(event,props.candidate_id)}
                onBlur={(event) => props.handleCandidateEmailOnBlur(event,props.candidate_id)}
                
              />:
              <p className="candidate-email">{ !props.isPreview && props.isProfileEdit ?
                 props.candidate.candidate_email&&props.candidate.candidate_email.trim() ? 
                 props.candidate.candidate_email
                 :"Add Email Address"
                :""}
              </p>
            }
            {(!props.isEmailEdit  && !props.isPreview && props.isProfileEdit) ?
              <Icon 
                icon="Candidate-name-edit" 
                className="candidate-name-edit-icon" 
                onClick={(event) =>props.handleCandidateEmailEdit(event)}
              ></Icon>
            :""}
            {props.errorPosition==='Email'?<p className='error-message'>Please enter valid Email</p>:""} 
                        
            </MediaQuery>
          </div>

          {(props.isCandidateScoring) ?
            <MediaQuery query="(min-device-width: 768px)">
              <div className="line"></div>
            </MediaQuery>
          : null }
          {(!props.isCandidateScoring) ?
            <div>
            <div className="line"></div>
            <div className="prev-experience-container">
              <h2 className="cs">Previous Experience</h2>
              {((props.candidate.experience.filter((exp) => (exp.current_role === "1" && exp.title !== "" /*&& exp.company !== "" */)).length > 1) || (props.candidate.experience.filter((exp) => (exp.current_role === "0" && exp.title !== "" /*&& exp.company !== ""*/)).length > 0)) ?
                <Row className={"show-grid previous-experience-content" + ((props.isProfileEdit && !props.isPreview) ? " previous-experience-content-full-width" : "") } >                            
                  <Col md={12}>
                    { (props.candidate.experience.filter((prevExp) => (prevExp.current_role === "0"  && prevExp.title.trim() !== "" /*&& prevExp.company.trim() !== "" */)).length > 0) ? 
                      props.candidate.experience.filter((prevExp) => (prevExp.current_role === "0" && prevExp.title !== "" /* && prevExp.company !== "" */)).map((prevExp, index) => {
                        if( index > 1) {
                          return;
                        } 
                        return (
                          <div className="highlight-experience" key={index}>
                            <span 
                              className="job-title">{prevExp.title}</span> | <span className="company">{prevExp.company?prevExp.company:"- Not Specified -"}</span> 
                          </div>
                        )
                      }) : '' }
                    {(props.isProfileEdit && !props.isPreview || props.isPrint) ? null : 
                      // <div className="ex-btn">
                      //   <Button 
                      //     className="all-experience btn" 
                      //     onClick={() => props.handleProfileTabSelect("experience")}
                      //   >
                      //     See all experience
                      //   </Button>  
                      // </div> 
                      null
                    }
                    
                  </Col>                                          
                </Row>
              : <span className="highlight-experience-nil">NA</span> }
            </div>
            <div className="lineb notice-period-line"></div>
            {(props.isProfileEdit && !props.isPreview ) ?               
              <div className="meta show-grid row">
                <div className="col-md-6 col-xs-12 notice-period-dropdown">
                 <span className="notice"></span>
                  <Select 
                    className="noticeDropdown"
                    id="noticePeriodId"
                    value={noticePeriodValue} onChange={(event) => props.handleNoticePeriodChange(event)} >
                     {noticePeriodOptions}                 
                  </Select>
                </div>
                <div className="col-md-6 col-xs-12  job-type-dropdown">
                 <span className="jobtype"></span>
                  <Select 
                    className="jobtypeDropdown"
                    id="jobTypeId"
                    value={jobTypeValue} onChange={(event) => props.handleJobTypeChange(event)}>
                      {jobTypeOptions}
                  </Select>
                </div>
              </div> 
              :
              <div className="meta show-grid row">
                <div className="col-md-6 col-xs-12">
                  <span className="notice">{ (props.candidate.notice_period && props.candidate.notice_period != "Immediately Available") ? props.candidate.notice_period + " Notice Period" : (props.candidate.notice_period == "Immediately Available")?"Immediately Available":"Notice Period: NA"}</span>
                </div>
                <div className="col-md-6 col-xs-12">
                  <span className="jobtype">Job Type: { (props.candidate.job_type && props.candidate.job_type !== null) ? 
                    (props.candidate.job_type==="Contract, Permanent"||props.candidate.job_type==="Permanent, Contract"?"Contract / Permanent": props.candidate.job_type)
                  : 'NA' }</span>
                </div>
              </div>
            }
          </div>
          : null }
        </div>
        {(props.isProfileEdit && !props.isPreview && props.candidate.last_edited)?
          <div className="last-edited-text">
            Last edit was made {moment().diff(props.candidate.last_edited.datetime, 'minutes')>2880 ?
            "on ":null} {relativeTime(props.candidate.last_edited.datetime)}  by {props.userId === props.candidate.last_edited.recruiterId? "You" :props.candidate.last_edited.recruiterName}
          </div>:
        ""}
      </div>    
  );
}

export default CandidateOverview;


// WEBPACK FOOTER //
// ./src/components/Client/CandidateOverview/CandidateOverview.js